import type {
  ApiResponse,
  ApproveRejectGiftcardRequest,
  PaginatedResponse,
  PaginationParams,
  PendingGiftcardSale,
  Transaction,
  TransactionFilters
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class TransactionService {
  async getTransactions(
    filters?: TransactionFilters
  ): Promise<ApiResponse<{ transactions: Transaction[] } & PaginatedResponse<Transaction>>> {
    return apiManager.get('/api/v1/admin/transactions', filters);
  }

  async getPendingGiftcardSales(
    params?: PaginationParams
  ): Promise<ApiResponse<{ giftcardSales: PendingGiftcardSale[] } & PaginatedResponse<PendingGiftcardSale>>> {
    return apiManager.get('/api/v1/admin/giftcard-sales/pending', params);
  }

  async approveRejectGiftcardSale(data: ApproveRejectGiftcardRequest): Promise<ApiResponse> {
    return apiManager.post('/api/v1/admin/giftcard-sales/approve-reject', data);
  }
}

export const transactionService = new TransactionService();